(function(){
  var ROUTES = (window.theme && window.theme.routes && window.theme.routes.cart) || {};
  var ADD_URL = (ROUTES.add || '/cart/add') + '.js';
  var CART_URL = (ROUTES.base || '/cart') + '.js';
  var EMPTY_HINT = ' Tema düzenleyicisinde bu kareyi seçip "Bu karedeki ürünler" kutusundan ekleyebilirsiniz.';

  function addItems(items){
    return fetch(ADD_URL, {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:items})
    }).then(function(res){
      return res.json().then(function(data){
        if(!res.ok){ var err = new Error(data.description || data.message || 'Sepete eklenemedi'); err.data = data; throw err; }
        return data;
      });
    });
  }
  function cartCount(){
    return fetch(CART_URL, {credentials:'same-origin', headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); }).then(function(c){ return c.item_count || 0; });
  }
  function notifyTheme(){
    try{ document.dispatchEvent(new CustomEvent('apps:product-added-to-cart')); }catch(e){}
  }
  function setLabel(btn, text){ var s = btn.querySelector('span'); if(s) s.textContent = text; else btn.textContent = text; }

  function init(root){
    if(root.dataset.fkReady) return;
    root.dataset.fkReady = '1';
    var sheet = document.getElementById(root.getAttribute('data-sheet'));
    var native = root.getAttribute('data-native') === '1';

    /* Sitenin kendi koleksiyon ızgarası (şablonda bu bölümün altına eklenen main-collection-product-grid) */
    var grid = null;
    var wrap = root.closest('.shopify-section') || root.parentElement;
    if(wrap){
      var n = wrap.nextElementSibling;
      while(n){ if(n.classList && n.classList.contains('collection-section')){ grid = n; break; } n = n.nextElementSibling; }
    }
    if(!grid) grid = document.querySelector('.fk-editoryal ~ .collection-section');

    /* Sekmeler */
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    function selectTab(id, remember){
      tabs.forEach(function(t, i){
        var on = t.id === id;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if(panel) panel.hidden = !on;
        if(i === 1 && grid) grid.classList.toggle('fk-show', on && native);
      });
      if(remember && history.replaceState){
        var isColl = tabs[1] && id === tabs[1].id;
        try{ history.replaceState(null, '', location.pathname + location.search + (isColl ? '#koleksiyon' : '')); }catch(e){}
      }
    }
    tabs.forEach(function(t, i){
      t.addEventListener('click', function(){ selectTab(t.id, true); });
      t.addEventListener('keydown', function(e){
        if(e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var nx = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        nx.focus(); selectTab(nx.id, true);
      });
    });
    var wantsCollection = location.hash === '#koleksiyon' || /[?&](filter\.|sort_by=|page=)/.test(location.search);
    selectTab(wantsCollection && tabs[1] ? tabs[1].id : tabs[0].id, false);

    /* Yedek ızgara: ürün türü çipleri (istemci tarafı) */
    var chipsBox = root.querySelector('[data-type-chips]');
    var cards = [].slice.call(root.querySelectorAll('.fk-grid .fk-pc'));
    if(chipsBox && cards.length){
      var types = {};
      cards.forEach(function(c){ var t = (c.getAttribute('data-type') || '').trim(); if(t) types[t] = (types[t] || 0) + 1; });
      var keys = Object.keys(types).sort(function(a, b){ return a.localeCompare(b, 'tr'); });
      if(keys.length > 1){
        var html = '<button type="button" class="fk-chip on" data-t="">TÜMÜ</button>';
        keys.forEach(function(k){ html += '<button type="button" class="fk-chip" data-t="' + k.replace(/"/g, '&quot;') + '">' + k + '<span>' + types[k] + '</span></button>'; });
        chipsBox.innerHTML = html; chipsBox.hidden = false;
        var countLabel = root.querySelector('[data-count-label]');
        chipsBox.addEventListener('click', function(e){
          var b = e.target.closest('.fk-chip'); if(!b) return;
          var t = b.getAttribute('data-t');
          [].slice.call(chipsBox.querySelectorAll('.fk-chip')).forEach(function(x){ x.classList.toggle('on', x === b); });
          var shown = 0;
          cards.forEach(function(c){ var ok = !t || (c.getAttribute('data-type') || '').trim() === t; c.hidden = !ok; if(ok) shown++; });
          if(countLabel) countLabel.textContent = shown + ' ÜRÜN';
        });
      }
    }

    /* Kart kaydırma göstergeleri */
    var lastScroll = 0;
    function pair(scroller, marks){
      if(!scroller) return;
      scroller.addEventListener('scroll', function(){
        lastScroll = Date.now();
        if(!marks.length) return;
        var i = Math.round(scroller.scrollLeft / Math.max(scroller.clientWidth, 1));
        marks.forEach(function(m, k){ m.classList.toggle('on', k === i); });
      }, { passive:true });
    }
    [].slice.call(root.querySelectorAll('.fk-pc-w')).forEach(function(w){
      var track = w.querySelector('.fk-pc-m');
      pair(track, [].slice.call(w.querySelectorAll('.fk-bars i')));
      if(track && window.matchMedia('(hover:hover)').matches){
        w.addEventListener('mouseenter', function(){ track.scrollTo({ left:track.clientWidth, behavior:'smooth' }); });
        w.addEventListener('mouseleave', function(){ track.scrollTo({ left:0, behavior:'smooth' }); });
      }
    });

    if(!sheet) return;
    var list = sheet.querySelector('.fk-list');
    var sub = sheet.querySelector('.fk-sub');
    var msg = sheet.querySelector('.fk-msg');
    var titleEl = sheet.querySelector('[data-sheet-title]');
    var allBtn = sheet.querySelector('[data-add-all]');
    var cartLink = sheet.querySelector('.fk-cart');
    var cartCountEl = sheet.querySelector('[data-cart-count]');
    var footer = sheet.querySelector('.fk-sh-f');
    var msgTimer = null;
    function syncFooter(){ if(footer) footer.hidden = allBtn.hidden && cartLink.hidden; }

    function say(text, isError){
      msg.textContent = text || '';
      msg.classList.toggle('err', !!isError);
      clearTimeout(msgTimer);
      if(text) msgTimer = setTimeout(function(){ msg.textContent = ''; }, 4500);
    }
    function refreshCartLink(){
      cartCount().then(function(c){
        if(cartCountEl) cartCountEl.textContent = c ? ' · ' + c + ' ÜRÜN' : '';
        cartLink.hidden = !c;
        syncFooter();
      }).catch(function(){});
    }
    function openPanel(title, subText, html){
      if(titleEl) titleEl.textContent = title;
      sub.textContent = subText || '';
      list.innerHTML = html;
      say('');
      var rows = [].slice.call(list.querySelectorAll('.fk-lk[data-vid]'));
      allBtn.hidden = rows.length < 2;
      allBtn.disabled = false; setLabel(allBtn, 'TÜMÜNÜ SEPETE EKLE');
      syncFooter();
      refreshCartLink();
      if(sheet.showModal) sheet.showModal(); else sheet.setAttribute('open', '');
      sheet.querySelector('.fk-sh-b').scrollTop = 0;
    }
    function openFor(shot){
      var holder = shot.closest('[data-panel-id]');
      var pid = holder ? holder.getAttribute('data-panel-id') : null;
      if(!pid) return;
      var src = root.querySelector('.fk-panels [data-src="' + pid + '"]');
      var count = src ? src.children.length : 0;
      var label = src ? (src.getAttribute('data-title') || '') : '';
      var hint = (window.Shopify && window.Shopify.designMode) ? EMPTY_HINT : '';
      openPanel('FOTOĞRAFTAKİ ÜRÜNLER',
        count ? (label + ' · ' + count + ' ÜRÜN') : label,
        count ? src.innerHTML : '<div class="fk-empty">Bu karedeki ürünler çok yakında burada.' + hint + '</div>');
    }
    function openProduct(handle){
      var row = root.querySelector('.fk-panels .fk-lk[data-handle="' + handle + '"]');
      if(!row) return;
      openPanel('SEPETE EKLE', '', row.outerHTML);
    }

    /* Kareler ve kart düğmeleri */
    root.addEventListener('click', function(e){
      if(!e.target.closest) return;
      var q = e.target.closest('[data-quick]');
      if(q){ e.preventDefault(); openProduct(q.getAttribute('data-quick')); return; }
      var shot = e.target.closest('.fk-shot');
      if(!shot) return;
      if(Date.now() - lastScroll < 350) return;
      openFor(shot);
    });
    root.addEventListener('keydown', function(e){
      if(e.key !== 'Enter' && e.key !== ' ') return;
      var shot = e.target.closest ? e.target.closest('.fk-shot') : null;
      if(!shot) return;
      e.preventDefault(); openFor(shot);
    });

    /* Panel: kapatma, beden seçimi, sepete ekleme */
    sheet.addEventListener('click', function(e){
      if(e.target === sheet){ sheet.close(); return; }
      if(!e.target.closest) return;
      if(e.target.closest('[data-close]')){ sheet.close(); return; }

      var sz = e.target.closest('.fk-sz-b');
      if(sz && !sz.disabled){
        var row = sz.closest('.fk-lk');
        [].slice.call(row.querySelectorAll('.fk-sz-b')).forEach(function(b){ var on = b === sz; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        row.setAttribute('data-vid', sz.getAttribute('data-vid'));
        return;
      }

      var add = e.target.closest('[data-add]');
      if(add){
        var r = add.closest('.fk-lk');
        var vid = r && r.getAttribute('data-vid');
        if(!vid) return;
        add.disabled = true; setLabel(add, 'EKLENİYOR…');
        addItems([{ id: parseInt(vid, 10), quantity: 1 }]).then(function(){
          setLabel(add, '✓ SEPETE EKLENDİ'); add.classList.add('done');
          notifyTheme(); refreshCartLink();
          say((r.getAttribute('data-name') || 'Ürün') + ' sepete eklendi.');
          setTimeout(function(){ add.disabled = false; add.classList.remove('done'); setLabel(add, 'SEPETE EKLE'); }, 2200);
        }).catch(function(err){
          add.disabled = false; setLabel(add, 'SEPETE EKLE');
          say(err.message || 'Sepete eklenemedi.', true);
        });
        return;
      }

      var all = e.target.closest('[data-add-all]');
      if(all){
        var rows = [].slice.call(list.querySelectorAll('.fk-lk[data-vid]'));
        if(!rows.length) return;
        all.disabled = true; setLabel(all, 'EKLENİYOR…');
        var ok = 0, fail = 0, i = 0;
        (function next(){
          if(i >= rows.length){
            all.disabled = false; setLabel(all, 'TÜMÜNÜ SEPETE EKLE');
            notifyTheme(); refreshCartLink();
            say(ok + ' ürün sepete eklendi' + (fail ? ', ' + fail + ' ürün eklenemedi (stok).' : '.'), !!fail && !ok);
            return;
          }
          var rw = rows[i++];
          addItems([{ id: parseInt(rw.getAttribute('data-vid'), 10), quantity: 1 }])
            .then(function(){ ok++; var b = rw.querySelector('[data-add]'); if(b){ b.classList.add('done'); setLabel(b, '✓ SEPETE EKLENDİ'); setTimeout(function(){ b.classList.remove('done'); setLabel(b, 'SEPETE EKLE'); }, 2600); } })
            .catch(function(){ fail++; })
            .then(next);
        })();
      }
    });
  }
  function boot(){ [].slice.call(document.querySelectorAll('.fk-ed')).forEach(init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
